import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from "react-icons/fa";
import { Link } from "react-router-dom";

const FooterLanding = () => (
  <footer className="bg-dark text-white py-4">
    <Container>
      <Row className="mb-4">
        <Col md={4} className="text-center text-md-start mb-3 mb-md-0">
          <h4 className="text-primary">SocialMediaAuto</h4>
          <p>
            Your go-to platform for automated social media management and
            insights.
          </p>
        </Col>

        <Col md={4} className="text-center mb-3 mb-md-0">
          <p>&copy; 2025 SocialMediaAuto. All rights reserved.</p>
        </Col>

        <Col md={4} className="text-center">
          <h5>Follow Us</h5>
          <div>
            <Link to="#" className="text-white mx-2">
              <FaFacebook size={24} />
            </Link>
            <Link to="#" className="text-white mx-2">
              <FaTwitter size={24} />
            </Link>
            <Link to="#" className="text-white mx-2">
              <FaLinkedin size={24} />
            </Link>
            <Link to="#" className="text-white mx-2">
              <FaInstagram size={24} />
            </Link>
          </div>
        </Col>
      </Row>
    </Container>
  </footer>
);

export default FooterLanding;
